export class Client {
  id: number;
  name: string;
  inpatientNursingAccess: boolean;
  nursingProceduralAncillaryAccess: boolean;
  defaultReportAccesstoShiftLeaders: boolean;
  ancillaryPatientUOS: boolean;
  timeAndAttendance: boolean;
  costCenterLimit: number;
  modifiedByUserName: string;
  modifiedDate: string;
  timePayCodeMappingAccess: boolean;
  hasDataRestrictions: boolean;
  disabled: boolean;
}
